export default "__VITE_ASSET__CJh6P2BD__"